import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "58",
  height: "61",
  viewBox: "0 0 58 61"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M28.775 33.55C19.525 33.55 12 26.026 12 16.775S19.524 0 28.775 0 45.55 7.524 45.55 16.775 38.026 33.55 28.775 33.55M53.375 61h-48.8A4.58 4.58 0 0 1 0 56.425c0-.207.043-5.14 3.736-10.065 2.15-2.867 5.094-5.145 8.75-6.768C16.953 37.607 22.5 36.6 28.976 36.6s12.023 1.007 16.488 2.992c3.657 1.626 6.6 3.901 8.75 6.768 3.694 4.926 3.737 9.858 3.737 10.065A4.58 4.58 0 0 1 53.375 61" }, null, -1)
  ]))]))
}
export default { render: render }